import React, { Fragment } from "react"
const Teaser = ({
  image,
  imageSmall,
  title,
  content,
  link,
  linkText,
  className,
  imgSize = "w=768&h=432&fit=scale",
  renderTitle
}) => (
  <div className={`overflow-hidden ${className}`}>
    <picture>
      {imageSmall && (
        <source
          media="(max-width: 767px)"
          srcSet={`${imageSmall.fields.file.url}?fl=progressive&w=767&fit=scale`}
        />
      )}
      {image && (
        <Fragment>
          <source
            media="(min-width: 768px)"
            srcSet={`${image.fields.file.url}?fl=progressive&${imgSize}`}
          />
          <img
            className="w-full md:mb-2"
            src={`${image.fields.file.url}?fl=progressive&&${imgSize}`}
            alt=""
          />
        </Fragment>
      )}
    </picture>
    <div className="py-4">
      {renderTitle(title)}
      <p className="text-gray-700 mb-4 text-base">
        {content.content[0].content[0].value}
      </p>
      {link && linkText && (
        <p className="mt-4 mb-4">
          <a
            className="bg-transparent border-solid font-semibold py-2 px-4 border border-gray-800 inline-block px-4 py-3 yksa-btn"
            href={link}
          >
            {linkText}
          </a>
        </p>
      )}
    </div>
  </div>
)
const Home = ({ client, contentId, headerId }) => {
  const [pageHeader, setPageHeader] = React.useState([])
  const [pageContent, setPageContent] = React.useState([])
  const [loadingState, setLoadingState] = React.useState(false)

  React.useEffect(() => {
    setLoadingState(true)
    Promise.all([client.getEntry(headerId), client.getEntry(contentId)]).then(
      response => {
        setPageHeader(response[0].fields)
        setPageContent(response[1].fields.items)
        setLoadingState(false)
      }
    )
  }, [client, contentId, headerId])

  if (loadingState) {
    return (
      <div className="container md:mx-auto md:p-4 text-center">
        <p>Ladataan sisältöä..</p>
      </div>
    )
  }
  return (
    <div className="container mx-auto md:px-4 text-gray-800">
      {pageHeader && pageHeader.teaser && pageHeader.teaser.fields && (
        <Teaser
          {...pageHeader.teaser.fields}
          renderTitle={title => (
            <div className="font-semibold text-3xl mb-2">{title}</div>
          )}
          imgSize="w=1536&h=574&fit=scale"
          className="md:mx-2 mb-6"
        />
      )}
      <div className="font-semibold text-3xl mx-2 mb-4">Arkiston aarteita</div>
      {pageContent && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
          {pageContent.map((item, i) => (
            <Teaser
              renderTitle={title => (
                <div className="font-semibold text-xl uppercase mb-2">{title}</div>
              )}
              key={item.sys.id}
              {...item.fields}
              className="mx-2"
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default Home
